module.exports = __webpack_public_path__ + "img/app_cover.601256f3.jpg";